import './offices-studios-header.scss'

import { useTranslation } from 'react-i18next'

export const useOfficeStudiosHeader = () => {
  const { t } = useTranslation()

  return {
    t,
  }
}
